import { CSSProperties, FC, ReactNode } from 'react';

import { useSensitiveValuesVisibilityStore } from '@/shared/store/sensitive-values-visibility.store';

type Size = 'small' | 'medium';

const PLACEHOLDER: Record<Size, string> = {
  medium: '$ 1 000 000.00',
  small: '$ 10 000.00',
};

export type SensitiveValueTextWrapperProps = {
  children: ReactNode;
  size?: Size;
  blurredWrapperStyle?: CSSProperties;
};

export const SensitiveValueTextWrapper: FC<SensitiveValueTextWrapperProps> = ({
  children,
  size = 'medium',
  blurredWrapperStyle,
}) => {
  const { isVisible } = useSensitiveValuesVisibilityStore();

  if (isVisible) {
    return <>{children}</>;
  }
  return (
    <div
      style={{
        ...blurredWrapperStyle,
        filter: 'blur(10px)',
      }}
    >
      {PLACEHOLDER[size]}
    </div>
  );
};
